import { apiClient } from "./ApiConfig";

export const GalleryApi = {
    uploadMedia: (body: FormData) => {
        return apiClient.post('/image-gallery/images', body, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
    },
    getMedia: () => {
        return apiClient.get('/image-gallery/images')
    },
    deleteMedia: (body: any) => {
        return apiClient.post('/image-gallery/delete-media', body)
    }
}